import Report from '../Report';
import FieldSet from '../FieldSet';
import Parameter from '../Parameter';

export default class DateField extends Parameter {
    // Date Minimum
    public Min: string;

    // Date Maximum
    public Max: string;

    /**
     * Constructeur DateField
     * @param Name 
     * @param Label 
     * @param Type 
     * @param EmptyText 
     * @param Selected 
     * @param Option 
     * @param Listeners 
     * @param Min Extends
     * @param Max Extends
     */
    constructor(Name: string = '', Label: string = '', Type: string = 'DateField', EmptyText: string = '', Selected: string = '', Option: object = {}, Listeners: Array<{ key: string; value: string }> = [], Min: string = '', Max: string = '' ) {
        super(Name, Label, Type, EmptyText, Selected, Option, Listeners);
        this.Min = Min;
        this.Max = Max;
    }

    //#region Methode Static
    
    // Enregistre la sous-class dans la class Parent
    static {
        Parameter.registerSubclass(DateField); 
    }

    //#endregion
    
    override HasValue(): boolean {
        return this.Min != null || this.Max != null;
    }

    /**
     * Propriété filtrées pour la création d'un objet DateField
     * @returns
     */
    override getProperties(): Array<[string, any]>{
        return Object.entries(this).filter(([key]) => 
            this.keysToFilter.includes(key) )
    }

    // Créations des clé pour filtrer les propriété de DateField
    override keysToFilter: string[] =  ['Label', 'Min', 'Max'];

    override create() : DateField{
        return new DateField(this.Name, this.Label, this.Type, this.EmptyText, this.Selected, this.Option, this.Listeners, this.Min, this.Max)
    }
}